import { useState }                 from 'react'
import styled                       from 'styled-components/macro'
import { Swiper, SwiperSlide }      from 'swiper/react'
import { Pagination, Keyboard }     from 'swiper'
import { SwiperStyle, SliderStyle } from './MaximizedGallery.Swiper.style'
import { SwiperNav }                from './MaximizedGallery.Navigation'
import { CatchSlide }               from './MaximizedGallery.catch'
import { ImgWrapper } from 'components/ImgContainer/ImgWrapper'

export const Slider = ({initial, images}) => {

  const [ activeIndex, setActiveIndex ] = useState(0)

  const swiper = {
    modules       : [Keyboard], //Pagination, add in array for pagination
    slidesPerView : 1,
    spaceBetween  : 20,
    initialSlide  : initial ?? 0,
    pagination    : { dynamicBullets: true },
    keyboard      : { enabled: true },
    onSlideChange : e => { setActiveIndex( e.activeIndex ) }
  }
  
  return (
    <StyleInjection>
      <Swiper {...swiper}>
         <SwiperNav activeIndex={activeIndex} {...{images}}/>
        { 
          images?.map((img, i) => (
            <SwiperSlide style={{ transform: "unset", backfaceVisibility: "unset" ,}} key={i}>
           <ImgWrapper
                         img={typeof img === 'string' ? img : img.url || img.Url} alt={`slide-${i}`} imgStyle={{
                          width: "100%",
                          height: "100%",
                          // maxWidth: "95vw",
                          // maxHeight: "80vh",
                          borderRadius: "6px",
                          objectFit: "contain",
                          userSelect: "none",
                          // -webkit-user-drag: none,
                        }}
                        style={{
                          width: 'fit-content'
                        }}
                        />
          {/* <img
              src={img.url}
              alt=""
              style={{
                display      : "block",
                width        : "100%",
                height       : "auto",
                maxHeight    : "calc(90vh - 120px)",
                objectFit    : "contain",
                borderRadius : "6px",
              }}
            /> */}
              {/* <Img src={img.url} alt='' style={{ borderRadius: '6px' }}/> */}
              <CatchSlide/>
            </SwiperSlide>
          ))
        }
      </Swiper>
    </StyleInjection>
  )
}

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  
`
const StyleInjection = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;   /* 👈 was: height: auto */
  ${SwiperStyle}
  ${SliderStyle}
`